import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import FollowershipsCard from "@components/entityTypes/projectFollowership/FollowershipsCard"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { AppState } from "@redux/reducer"
import { selectCurrentUser } from "@redux/reducer/auth"
import { loadCurrentUserAction } from "@redux/usecases/userAccount"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"

const usedNamespaces: NamespaceShortcut[] = ["my-projects"]

export const followershipsListCardHashId = "FollowershipsList"

/**
 * This component wraps the `FollowershipsCard` and supplies it with the followerships that shall be shown.
 * NOTE that for currentUser, followerships are always fully filled with (IProject) objects, never with IRIs, so no extra loading is necessary.
 */
const MyFollowershipsCard: React.FC = () => {
  const t = useDynamicTranslation()

  const dispatch = useDispatch()

  const currentUser = useSelector((state: AppState) => selectCurrentUser(state))

  useEffect(() => {
    if (!currentUser) {
      dispatch(loadCurrentUserAction())
    }
  }, [])

  return <FollowershipsCard
    cardTitle={t("my-projects", "followerships")}
    followerships={currentUser.followerships}
    listCardHashId={followershipsListCardHashId}
  />
}

export default withDynamicNamespaces(MyFollowershipsCard, usedNamespaces)
